import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import {DialogActions, DialogContentText, Stack, Snackbar, Alert, LinearProgress} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Dialog from '@material-ui/core/Dialog';
import QuestionEdit from './QuestionEdit';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import QuestionViewInc from './QuestionViewInc';
import 'font-awesome/css/font-awesome.min.css';
import '../styles/bizofficer-a.css';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import axios from 'axios';
import Cookies from 'js-cookie';

var vertical='top',horizontal='center';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector(state => state.userDetails);
  const childRefEdit = React.useRef();  
  const [open, setOpen] = React.useState(false);
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

  const [pageLoading, setPageLoading] = React.useState(true);
  const [myQuestion, setMyQuestion] = React.useState({}); 
  const [dataObj, setDataObj] = React.useState({});
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [qRowIndex, setQRowIndex] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {	
    if(open && props?.dataObj?.autoId && userObj?.loginId && userObj?.token){	
      getApiQuestions();
      setMyQuestion(JSON.parse(props?.dataObj?.questionJson));
    }
	}, [props.dataObj,open]);
  
	async function getApiQuestions(){
		///alert(userObj.token);
		if(props?.dataObj?.autoId>0){
			setPageLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 

			axios.get(env.API_URL+"/exams/read/question-grouped?id="+props?.dataObj?.autoId, axiosHeader) 
			   .then(response => {
				//document.write(JSON.stringify(response));
				 setPageLoading(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';

				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response?.data?.obj);
					
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
		}	
	}


  function deleteData(){
		if(dataObj!=null && userObj.loginId && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'
				}
			}; 

			setIsDeleting(true);
		  setDeleteDialogShow(false);

		  const data = new FormData();
			data.append('id', dataObj?.autoId?dataObj.autoId:0);
		   
		  axios.post(env.API_URL+'/exams/delete/question-grouped', data, axiosHeader)
				.then((response) => {
					setIsDeleting(false);		
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          document.getElementById(qRowIndex).style.display='none';
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Question has been deleted");
					return false;
				}else{
		  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Question could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	
		
	}

  function hideAlert(){
		setShowAlert(false);
	}

  function deleteDialogHide(){
    setQRowIndex("");
		setDataObj({});
    setDeleteDialogShow(false);
	}

  function deleteQue(obj,rwIndex){
    setQRowIndex(rwIndex);
    setDataObj(obj);
    setDeleteDialogShow(true);
  }

  function editQue(obj){
    setDataObj(obj);
    childRefEdit.current.handleClickOpen();  
  }

  function reloadFlag(flag){
    if(flag===true){
      getApiQuestions();
    }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
              <div className="btmbdrgry"><h3>{props?.dataObj?.questionType}</h3></div>
              {pageLoading?<LinearProgress />:null}
              <p>              
					        <QuestionViewInc question={myQuestion} />

                  {rows?rows.map((row,i)=>(
                    <div id={'divIdQb'+i} key={'qw'+i} >
                      <QuestionViewInc question={JSON.parse(row?.questionJson)} num={i+1} />
                      						{(props.updateBtn && props.privileges && props.privileges.length>0 && props.privileges.indexOf("update")>-1)?
													<i onClick={()=>{editQue(row)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
 											{(props.updateBtn && props.privileges && props.privileges.length>0 && props.privileges.indexOf("delete")>-1)?<>
													{(qRowIndex==='divIdQb'+i && isDeleting)?
														<LoadingButton loadingPosition='start' startIcon={<div style={{marginRight:18}}></div>} loading={isDeleting} style={{backgroundColor:'#ff6e00',color:'#FFF',marginLeft:10}} size="small" variant="contained"  >Deleting...</LoadingButton>
													:<>
														<i onClick={()=>{deleteQue(row,'divIdQb'+i)}} title="Delete" className="fa fa-trash" style={{fontSize:30, color:'#ff0000',marginLeft:15, cursor:'pointer'}} />
													</>
													}
											</>:null}
                    </div>
                  )):null}

				      </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
      <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
			</Dialog>

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

      <QuestionEdit dataObj={dataObj} editCD={true} reloadFlag={reloadFlag} ref={childRefEdit} />

    </>
  );

});

export default CustomizedDialogs;